import React from "react";
import styles from "./version-selector.styles.css";
import CprSelect from "cpr-select";
import { setActiveRevision } from "./toggle-modes.js";

export default class RevisionSelector extends React.PureComponent {
  render() {
    const { revisions, activeRevision } = this.props;

    return (
      <div className={styles.root}>
        <CprSelect
          options={revisions.map(revision => ({
            key: revision.id,
            value: revision.name,
          }))}
          onChange={this.updateRevision}
          placeholder="Select a revision"
          selected={activeRevision.id}
        />
      </div>
    );
  }

  updateRevision = revision => {
    setActiveRevision(revision);
  };
}
